import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logAnalyticsEvent } from '../config/firebase';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views (deferred to avoid blocking render)
    if (typeof window !== 'undefined') {
      // Use requestIdleCallback for non-critical analytics
      const trackPageView = () => {
        logAnalyticsEvent('page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title,
        });
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(trackPageView, { timeout: 2000 });
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(trackPageView, 100);
      }
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;

